<app-api-loader></app-api-loader>
<div class="w-100 main">
  <div class="w-100">
    <router-outlet></router-outlet>
  </div>

  <!-- Floating Chat Button -->
  <div
    class="chat-icon d-flex justify-content-center align-items-center"
    (click)="toggleChat()"
    (keyup.enter)="toggleChat()"
  >
    <img [src]="isChatOpen ? '/icons/ic_close_chat.svg' : '/icons/ic_support_chat.svg'" alt="" />
  </div>

  <!-- Chat Box -->
  <div class="chat-box" *ngIf="isChatOpen">
    <div class="chat-header d-flex justify-content-between align-items-end p-4">
      <div class="d-flex flex-column mb-3">
        <h4 class="m-0 ff-poppins-semibold">Hi there 👋</h4>
        <h4 class="m-0 ff-poppins-semibold">How can we help?</h4>
      </div>
      <img src="/icons/ic_chat_header_icon.svg" alt="" />
    </div>
    <div class="p-3 mt-3">
      <div class="accordion" id="chatAccordion">
        <!-- WhatsApp -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="false"
              aria-controls="collapseOne"
            >
              <img src="/icons/ic_chat_whatsapp.svg" alt="" class="me-2" />
              Whatsapp
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse"
            aria-labelledby="headingOne"
            data-bs-parent="#chatAccordion"
          >
            <div class="accordion-body">
              <a
                class="w-100 text-decoration-none"
                href="https://wa.me/{{ supportPhone }}"
                target="_blank"
              >
                • {{ supportPhoneShow }}
              </a>
            </div>
          </div>
        </div>

        <!-- Email -->
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              <img src="/icons/ic_chat_email.svg" alt="" class="me-2" /> Email
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#chatAccordion"
          >
            <div class="accordion-body">
              <a
                class="w-100 text-decoration-none"
                href="mailto:{{ supportEmail }}?subject=Support%20Request&body=Hello%20team,"
              >
                • {{ supportEmail }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
